import React, { Component } from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import Well from 'react-bootstrap/lib/Well';

class CollapsablePanel extends Component {
    constructor(props, context) {
        super(props, context);
    
        this.state = {
          collapsed: {}
        };
      }

    getCollapseState(location){
        return this.state.collapsed[location] || {}
    }

    setCollapseState(location, key){
        let newState = {
            collapsed: {
                [location]: {
                    ...this.getCollapseState(location),
                    [key]: !this.getCollapseState(location)[key]
                }
            }
        };
        
        this.setState(newState);
    }
    
    render(){
        return (<div>
            <a className={this.props.className} onClick={()=>this.setCollapseState(this.props.location, this.props.section)}>
               <i className={this.getCollapseState(this.props.location)[this.props.section] ? 'fa fa-arrow-down':'fa fa-arrow-right'}></i>&nbsp;{this.props.title}
            </a>
        <Collapse in={this.getCollapseState(this.props.location)[this.props.section]}>
        <div>
            <Well className="collapse-panel" data-section={this.props.section}>
                {this.props.children}
            </Well>
       </div>
       </Collapse>
       </div>);
    }
}

export default CollapsablePanel;


// WEBPACK FOOTER //
// app/containers/CollapsePanel.jsx